var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker"},[_c('date-picker',{attrs:{"type":"datetime","confirm":true,"clearable":false,"editable":false,"confirm-text":_vm.confirmText,"placeholder":_vm.placeholder,"value":_vm.value,"disabled-date":_vm.disableBeforeToday},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }